import React from 'react';
import './App.css';
import {RouterProvider} from "react-router-dom";
import routes from "services/routes";
import {ConfigProvider} from "antd";
import themeConfig from "theme";
import {DraftProjectContext, ProjectContext, UserContext} from 'services/contexts';
import {DraftProjectProvider, ProjectProvider, UserProvider} from "services/providers";

function App() {
    return (
        <UserProvider>
            <UserContext.Consumer>
                {({user}) => (
                    <DraftProjectProvider>
                        <DraftProjectContext.Consumer>
                            {({draftProject}) => (
                                <ProjectProvider>
                                    <ProjectContext.Consumer>
                                        {({selectedProject}) => (
                                            <ConfigProvider theme={themeConfig}>
                                                <RouterProvider
                                                    router={routes}
                                                    fallbackElement={<p>Initial Load...</p>}
                                                />
                                            </ConfigProvider>
                                        )}
                                    </ProjectContext.Consumer>
                                </ProjectProvider>

                            )}
                        </DraftProjectContext.Consumer>
                    </DraftProjectProvider>
                )}
            </UserContext.Consumer>
        </UserProvider>
    );
}

export default App;
